var a;!function(a){a.EUR="EUR",a.CHF="CHF"}(a||(a={}));var r=a;export{a as Currency,r as default};
